'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import PropTypes from 'prop-types';
import Rating from 'ecosystem-marketplace-core/components/reviews/Rating';
import ReviewBody from 'ecosystem-marketplace-core/components/reviews/ReviewBody';
import ReviewerInfo from 'ecosystem-marketplace-core/components/reviews/ReviewerInfo';
import QualityDistribution from 'ecosystem-marketplace-core/components/reviews/QualityDistribution';
import ReviewReplyThread from 'ecosystem-marketplace-core/components/reviews/ReviewReplyThread';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import * as ReviewTypes from 'ecosystem-marketplace-core/constants/reviews/ReviewType';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { RatingAxes } from 'ecosystem-marketplace-core/constants/reviews/RatingAxes';
import Review from 'ecosystem-marketplace-core/records/Review';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UISection from 'UIComponents/section/UISection';
import withReportModalState from './withReportModalState'; // Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls the Renderer to display each one

const AllReviewsReviewRenderer = ({
  borderBottom,
  isCustomer,
  onReplyModalOpen,
  review,
  reviewModalOpen,
  replyModalOpen,
  reportReviewModal,
  reportReplyModal,
  reviewActionsList,
  searchTerm
}) => {
  const {
    gridClassName
  } = useResponsiveProps({
    gridClassName: {
      xs: 'flex-column m-bottom-4',
      sm: 'flex-row justify-between align-top m-bottom-4',
      md: 'flex-column'
    }
  });
  return /*#__PURE__*/_jsxs(UIGrid, {
    className: "p-y-8",
    style: {
      width: '100%',
      borderBottom: borderBottom && `1px solid ${GREAT_WHITE}`
    },
    children: [/*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        xs: 12,
        md: 5,
        lg: 4
      },
      className: gridClassName,
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-8",
        children: /*#__PURE__*/_jsx(ReviewerInfo, {
          review: review
        })
      }), /*#__PURE__*/_jsx(QualityDistribution, {
        qualityRatings: review.getQualityRatings(),
        reviewType: ReviewTypes.APP
      })]
    }), /*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        xs: 12,
        md: 7,
        lg: 8
      },
      className: "flex-column",
      children: [/*#__PURE__*/_jsx(UISection, {
        children: /*#__PURE__*/_jsx(Rating, {
          rating: review.get('ratings').get(RatingAxes.OVERALL),
          label: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: review.get('createdAt'),
            format: "ll",
            type: "userTz"
          })
        })
      }), /*#__PURE__*/_jsx(ReviewBody, {
        review: review,
        searchTerm: searchTerm
      }), reviewActionsList, /*#__PURE__*/_jsx(ReviewReplyThread, {
        reply: review.get('reply'),
        onReportReplyClick: isCustomer ? onReplyModalOpen : undefined
      }), reviewModalOpen && reportReviewModal, replyModalOpen && reportReplyModal]
    })]
  });
};

AllReviewsReviewRenderer.propTypes = {
  borderBottom: PropTypes.bool,
  isCustomer: PropTypes.bool.isRequired,
  onReplyModalOpen: PropTypes.func.isRequired,
  review: PropTypes.instanceOf(Review).isRequired,
  reviewModalOpen: PropTypes.bool.isRequired,
  replyModalOpen: PropTypes.bool.isRequired,
  reportReviewModal: PropTypes.node.isRequired,
  reportReplyModal: PropTypes.node.isRequired,
  reviewActionsList: PropTypes.node.isRequired,
  searchTerm: PropTypes.string
};
export default withReportModalState(AllReviewsReviewRenderer);